module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mia Ross\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Mia Ross loves great stories. She enjoys reading about fascinating people, long-ago times, and exotic places. But only for a little while, because her reality is pretty sweet. A lifelong resident of Upstate New York, she's married and the proud mom of 2 amazing kids whose schedules keep her hopping. Busy as she is, she can't imagine trading her life for anyone else's--and she has a pretty good imagination. You can visit her online at www.miaross.com.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8b82Qz/images/9781488006999_fmt.jpeg?1694778388253",
      "alt": "This image is the cover for the book Her Small-Town Cowboy, Oaks Crossing"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Small-Town Cowboy, Oaks Crossing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("He’s too busy saving his family’s horse farm to bother with love—but a partner may be just what he needs . . .")]), _c('br'), _c('br'), _vm._v("Lily St. George dreams of marriage and a family of her own. But as a temporary kindergarten teacher, she can’t get too attached to anyone in Oaks Crossing, Kentucky. When a student brings in her single father for show-and-tell, Lily is drawn to charming cowboy Mike Kinley. Working overtime to save his struggling horse farm, Mike claims to have no room in his life for love. But when they team up to start a riding school for children at his ranch, Lily knows she’ll have to help Mike see their partnership is meant to be permanent . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0